<template>
    <div class="relative min-h-screen min-w-screen flex flex-col justify-between pb-8">
        <div class="pb-32">
            <default-header 
                type="dark"
                :title="$t('thankyou')"
                :text="$t('passesexpired')"
                headerClasses="pb-0"
                :masked="false"
            />
            <img src="@/assets/images/sms.png" alt="" class="w-full max-w-xs mx-auto py-10 px-8">
        </div>
    </div>
</template>

<script>
import DefaultHeader from "@/components/Header.vue";

export default {
  components: {
    DefaultHeader
  },
  data() {
    return {
    };
  },
  methods: {

  }
};
</script>

<style lang="scss">

</style>